// document ready function
export function ready(fn) {
	if (document.readyState === 'complete') {
		fn();
	} else {
		document.addEventListener('DOMContentLoaded', fn);
	}
}
// window scroll function
export function onScroll(fn) {
    // Call the callback immediately with the current scroll position
    fn(window.pageYOffset);
    // Define the scroll event handler
    const handleScroll = () => {
      fn(window.pageYOffset);
    };
    // Attach the scroll event listener
    window.addEventListener('scroll', handleScroll);
    // Return a function to remove the event listener when needed
    return () => window.removeEventListener('scroll', handleScroll);
}